import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import './PrimaryButton.css';
import { getButtonProps } from '../util/buttonProps';
function PrimaryButton(props) {
  const {
    label,
    href,
    type,
    disabled,
    onClick
  } = props;
  const baseProps = getButtonProps(props, 'Primary');
  return href && !disabled ? /*#__PURE__*/React.createElement("a", _extends({}, baseProps, {
    href: href
  }), props.children || label) : /*#__PURE__*/React.createElement("button", _extends({}, baseProps, {
    type: type,
    onClick: onClick,
    onKeyDown: onClick,
    disabled: disabled
  }), props.children || label);
}
PrimaryButton.defaultProps = {
  id: '',
  className: '',
  label: '',
  href: '',
  type: 'button',
  disabled: false
};
export default PrimaryButton;